export const getSignupEmailTemplate = (signupEmail, signupTier) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background-color: #1c293a; color: white; padding: 20px; text-align: center; }
        .content { background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; }
        .field { margin-bottom: 15px; }
        .field strong { color: #1c293a; }
        .plan-badge { 
          display: inline-block; 
          background-color: #1c293a; 
          color: white; 
          padding: 8px 16px; 
          border-radius: 20px; 
          font-weight: bold; 
          text-transform: uppercase;
          font-size: 12px;
          margin-top: 5px;
        }
        .footer { text-align: center; margin-top: 20px; color: #666; font-size: 14px; }
        .highlight { background-color: #e8f4f8; padding: 15px; border-left: 4px solid #1c293a; margin: 15px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h2>🎉 New User Registration</h2>
        </div>
        <div class="content">
          <div class="highlight">
            <p><strong>Great news!</strong> A new user has registered on the Walkspan platform.</p>
          </div>
          
          <div class="field">
            <strong>Email Address:</strong><br>
            <span style="color: #1c293a; font-weight: 500;">${signupEmail}</span>
          </div>
          
          <div class="field">
            <strong>Selected Plan:</strong><br>
            <span class="plan-badge">${signupTier.charAt(0).toUpperCase() + signupTier.slice(1)} Tier</span>
          </div>
          
          <div style="margin-top: 25px; padding-top: 20px; border-top: 1px solid #ddd;">
            <p style="margin: 0; color: #666; font-size: 14px;">
              This is an automated notification from the Walkspan registration system.
            </p>
          </div>
        </div>
        
        <div class="footer">
          <p>Best regards,<br><strong>Walkspan Registration System</strong></p>
        </div>
      </div>
    </body>
    </html>
  `;
};
